(function () {
  function addBusinessDays(date, days) {
    const result = new Date(date);

    while (days > 0) {
      result.setDate(result.getDate() + 1);

      const day = result.getDay();

      // Ignore Saturday (6) and Sunday (0)
      if (day !== 0 && day !== 6) {
        days--;
      }
    }

    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric'
    });
  }

  function updateDeliveryEstimate() {
    document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      const minDays = parseInt(el.dataset.minDays, 10);
      const maxDays = parseInt(el.dataset.maxDays, 10);

      const today = new Date();

      const minDate = addBusinessDays(today, minDays);
      const maxDate = addBusinessDays(today, maxDays);

      el.textContent =
  ' ' +
  formatDate(minDate) +
  ' – ' +
  formatDate(maxDate);
    });
  }

  document.addEventListener('DOMContentLoaded', updateDeliveryEstimate);
})();